// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"MaskActionButton_iconWrapper__sYQSq"};